import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { getCookie } from 'cookies-next';

import resetTokenToCookie from '~utils/auth/resetTokenToCookie';
import setTokens from '~utils/auth/setTokens';
import { isClient } from '~utils/lodash/isServer';

interface ErrorData {
  type?: string;
  message: string;
  status: number;
}
const instance = axios.create();

const interceptorsRequestFulfilled = (config: AxiosRequestConfig) => {
  const token = isClient ? getCookie('accessToken') : config.params?.accessToken;
  if (token && token !== undefined && token !== 'undefined') {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    };
  }

  // config.baseURL
  return config;
};

const interceptorsResponseFulfilled = (res: AxiosResponse) => {
  if (res.status >= 200 && res.status < 300) {
    return res;
  }

  return Promise.reject(res);
};

const interceptorsResponseRejected = async (error: AxiosError<ErrorData>) => {
  /**
   * refresh token 처리 로직
   */
  const parsedExtraData = error.config.data ? JSON.parse(error.config.data) : {};
  try {
    if (error.response?.data?.type === 'invalid_token') {
      const refreshToken = isClient && getCookie('refreshToken');

      const { data } = await axios.get('/api/auth/refresh', {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      });

      const { accessToken } = data;
      setTokens(accessToken);
      window.location.reload();
    }

    return Promise.reject(error.response ?? error);
  } catch (refreshError: unknown) {
    resetTokenToCookie();

    if (!parsedExtraData?.notReloadOnInvalidToken) {
      window.location.reload();
    }

    return Promise.reject(refreshError?.response ?? refreshError);
  }
};

instance.interceptors.request.use(interceptorsRequestFulfilled);
instance.interceptors.response.use(interceptorsResponseFulfilled, interceptorsResponseRejected);
export function get<T>(...args: Parameters<typeof instance.get>) {
  return instance.get<T, T>(...args);
}

export function post<T>(...args: Parameters<typeof instance.post>) {
  return instance.post<T, T>(...args);
}

export function put<T>(...args: Parameters<typeof instance.put>) {
  return instance.put<T, T>(...args);
}

export function patch<T>(...args: Parameters<typeof instance.put>) {
  return instance.patch<T, T>(...args);
}

export function del<T>(...args: Parameters<typeof instance.delete>) {
  return instance.delete<T, T>(...args);
}
